module.exports = __webpack_public_path__ + "static/media/serviceIndustry3.8ecff3b4.png";